module.exports = __webpack_public_path__ + "static/assets/5e8cdc5c6a26831d0eae9b14ca3eafff.png";